import { render, staticRenderFns } from "./FrenchWindowImpacts.vue?vue&type=template&id=754318d4&scoped=true"
import script from "./FrenchWindowImpacts.vue?vue&type=script&lang=ts"
export * from "./FrenchWindowImpacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754318d4",
  null
  
)

export default component.exports